import { useLocaleData, useT } from "../../i18n/useT";
import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";

const Experience = () => {
  const t = useT();
  const items = useLocaleData("sections.experience.items") || [];

  return (
    <section className="p-3 p-lg-5 d-flex flex-column" id="experience">
      <h1 className="text-uppercase mb-4">{t("sections.experience.title")}</h1>
      {items.map((item, idx) => (
        <div className="row my-4" key={idx}>
          <div className="col-md-8">
            <h3 className="text-uppercase">{item.company}</h3>
            <h4 className="text-secondary">{item.role}</h4>
            {item.description && (
              <p className="text-secondary">{item.description}</p>
            )}
            {Array.isArray(item.bullets) && item.bullets.length > 0 && (
              <ul className="text-secondary">
                {item.bullets.map((bullet, bIdx) =>
                  typeof bullet === "string" ? (
                    <li key={bIdx}>{bullet}</li>
                  ) : (
                    <li key={bIdx}>
                      {bullet.text}
                      {Array.isArray(bullet.items) &&
                        bullet.items.length > 0 && (
                          <ul>
                            {bullet.items.map((sub, sIdx) => (
                              <li key={sIdx}>{sub}</li>
                            ))}
                          </ul>
                        )}
                    </li>
                  )
                )}
              </ul>
            )}
          </div>
          <div className="col-md-4">
            <p
              className="text-primary tooltip-element"
              data-tooltip-content={item.duration || item.tooltip || ""}
            >
              {item.period}
            </p>
          </div>
        </div>
      ))}
      <ReactTooltip anchorSelect=".tooltip-element" />
    </section>
  );
};

export default Experience;
